<template>
    <div>
        <h1 class="page-title">Mises en avant catégories</h1>
    </div>
    <div class="flex justify-end w-full">
        <Button
            label="Ajouter une mise en avant"
            @click="addHilight"
            icon="pi pi-plus"
            aria-label="Ajouter une mise en avant"
            class="button-add"
        />
    </div>
    <div class="card">
        <DataTable
            :value="tableData"
            :paginator="true"
            :rows="rowsPerPage"
            :totalRecords="totalRecords"
            :currentPage="currentPage"
            :rowsPerPageOptions="[10, 25, 50, 100]"
            @page="onPaginate"
            lazy
        >
       
            <div class="card-body pt-0">
                <Column field="name" header="Nom du lien" />
                <Column field="category.name" header="Catégorie" />
                <Column headerStyle="width: 12em;">
                    <template #header>
                        <div>Actions</div>
                    </template>
                    <template #body="slotProps">
                        <Button
                            size="small"
                            icon="pi pi-pencil"
                            class="p-edition"
                            :class="`${slotProps.data.uuid}`"
                            style="margin-right: 0.5em"
                            title="Éditer"
                            @click="editMegaMenu(slotProps.data.uuid)"
                        />
                        <Button
                            size="small"
                            icon="pi pi-trash"
                            class="p-button-danger"
                            style="margin-right: 0.5em"
                            title="Supprimer"
                            @click="onDelete(slotProps.data.uuid)"
                        >
                        </Button>
                    </template>
                </Column>
            </div>
            <template #empty>Aucun résultat trouvé.</template>
        </DataTable>
    </div>
</template>

<script lang="ts" setup>
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import Property from "@/models/product/property/Property";
import { ref, onMounted } from "vue";
import {fetchProperties} from "@/_services/property/property";
import {FilterMatchMode} from "primevue/api";
import router from "@/router";
import {deleteMegaMenuCategories, fetchMegaMenuCategories} from "@/_services/megaMenuCategories/megaMenuCategories";
import {IMasterProduct} from "@/models/product/IMasterProduct";
import swal from "@/_helpers/swal";
import {productService} from "@/_services/product/product";
const currentPage = ref(1);
const rowsPerPage = ref(10);
const totalRecords = ref(0);
const rows = ref<number>(10);
const isLoading = ref<boolean>(true);
const properties = Array<Property>();
const tableData = ref<Array<Property>>(properties);
const editMegaMenu = (megaMenuUuid: string) => {
    router.push({ name: 'editMegaMenusCategories', params: { uuid: megaMenuUuid } });
};
onMounted(async () => {
    await populateDatatable();
});
const populateDatatable = async () => {
    const paginationData = await fetchMegaMenuCategories(currentPage.value, rowsPerPage.value);
    isLoading.value = paginationData.isLoading.value;
    tableData.value = paginationData.tableData.value;
    console.log(tableData.value)
    totalRecords.value = paginationData.totalRecords.value;
};

const onPaginate = (event) => {
    currentPage.value = event.page + 1; 
    rowsPerPage.value = event.rows;
    populateDatatable();
};
const onDelete = (megaMenuUuid) => {
    swal
        .confirm("Êtes vous sur de vouloir supprimer cette mise en avant ?")
        .then((result) => {
            if (result.isConfirmed) {
                 deleteMegaMenuCategories(megaMenuUuid).then(() => {
                    swal.success("Supprimé !", "Vous venez de supprimer cette mise en avant ");
                    populateDatatable();
                });
            }
        });
};

const addHilight = () => {
    router.push("/admin/catalogue/megaMenusCategories/add");
   
}

</script>